var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"markdown-content pre-wrap",domProps:{"innerHTML":_vm._s(_vm.renderedMarkdown)}})
}
var staticRenderFns = []

export { render, staticRenderFns }